console.log('process.env', process.env)
const serverList = [
    {
        BASEURL: 'http://192.168.68.106:8401',
    },
    {
        BASEURL: 'https://gameapi.etuw.cn',
    },
];
let serverArr;

serverArr = process.env.VUE_APP_TOOL_LOGIN_LOCAL === '1' ? { BASEURL: '/game-api' } : serverList[1]
export default serverArr
